import script from "./ContestDetail.vue?vue&type=script&setup=true&lang=js"
export * from "./ContestDetail.vue?vue&type=script&setup=true&lang=js"

import "./ContestDetail.vue?vue&type=style&index=0&id=08bba1ff&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-08bba1ff"]])

export default __exports__